"use client";

import type { CommunityMembersSchema } from "../../../../../../lib/types/schema/community/members/communityMembersSchema";
import { getRequestNextPageParam } from "../../../../../../lib/utils/getRequestNextPageParam";
import { useRequestInfiniteQuery } from "../../../../../../request/hooks/useRequestInfiniteQuery";
import { keyCommunityAssignmentCompletions } from "./keyCommunityAssignmentCompletions";
import { communityAssignmentCompletionsSchema } from "./schema/communityAssignmentCompletionsSchema";

const PAGE_SIZE = 25;

type UseRequestCommunityAssignmentCompletionsProps = {
  assignmentId: number;
  classId: number;
  search?: string;
};

export const useRequestCommunityAssignmentCompletions = ({
  assignmentId,
  classId,
  search,
}: UseRequestCommunityAssignmentCompletionsProps) => {
  return {
    infiniteQuery: useRequestInfiniteQuery<any>({
      getNextPageParam: (
        lastPage: CommunityMembersSchema,
        _allPages: CommunityMembersSchema[],
        lastPageParam: number,
      ) =>
        getRequestNextPageParam({
          total: lastPage.total,
          lastPageParam,
          pageSize: PAGE_SIZE,
        }),
      initialPageParam: 0,
      queryFnRequestProps: ({ pageParam }) => ({
        schema: communityAssignmentCompletionsSchema,
        urlBackendPath: `/communities/${classId}/admin/assignments/${assignmentId}/completions?page=${pageParam}&page_size=${PAGE_SIZE}&search=${search}`,
      }),
      enabledWithoutSessionToken: false,
      queryKey: keyCommunityAssignmentCompletions({
        assignmentId,
        classId,
        search,
      }),
    }),
  };
};
